import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  FetchExerciceByIdRequest,
  UpdateExerciceRequest,
  FetchExercicesRequest,
  CreateExerciceRequest,
  DeleteExerciceRequest,
  EndExerciceRequest,
  UndoExerciceRequest,
  FetchAllExercicesRequest,
} from './types'
import {AxiosError} from 'axios'
import {ResponseError} from '../commonTypes'
import {Exercice} from '../../../models'
import axios from 'axios'
import {
  fetchExercicesUrl,
  fetchExerciceByIdUrl,
  createExerciceUrl,
  updateExerciceUrl,
  deleteExerciceUrl,
  endExerciceUrl,
  undoExerciceUrl,
  fetchAllExercicesUrl,
} from '../../api'

export const fetchExercices = createAsyncThunk(
  'exercice/fetch',
  async (payload: FetchExercicesRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchExercicesUrl}?sortField=${payload.sortField}&sortOrder=${
          payload.sortOrder
        }&pageNumber=${payload.pageNumber}&pageCount=${payload.pageCount}${
          payload.search && payload.search.trim() !== '' ? '&search=' + payload.search.trim() : ''
        }${payload.done !== undefined ? '&done=' + payload.done : ''}${
          payload.teachers ? '&teachers=' + payload.teachers : ''
        }${payload.classrooms ? '&classrooms=' + payload.classrooms : ''}${
          payload.students ? '&students=' + payload.students : ''
        }${payload.subjects ? '&subjects=' + payload.subjects : ''}&role=${payload.role}`
      )
      const {exercices, totalPages, total} = res.data
      return {
        exercices,
        totalPages,
        total,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchAllExercices = createAsyncThunk(
  'exercice/fetchAll',
  async (payload: FetchAllExercicesRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchAllExercicesUrl}`)
      const {exercices} = res.data
      return {
        exercices,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchExerciceById = createAsyncThunk(
  'exercice/fetchById',
  async (payload: FetchExerciceByIdRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchExerciceByIdUrl}/${payload.id}`)
      const {exercice} = res.data
      return {
        exercice,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const createExercice = createAsyncThunk(
  'exercice/create',
  async (payload: CreateExerciceRequest, {rejectWithValue}) => {
    try {
      const data = new FormData()
      data.append('title', payload.title)
      data.append('deadline', payload.deadline)
      data.append('classrooms', JSON.stringify(payload.classrooms))
      data.append('establishement', payload.establishement)
      data.append('specificStudents', JSON.stringify(payload.specificStudents))
      data.append('toStudents', JSON.stringify(payload.toStudents))
      data.append('subject', payload.subject)
      data.append('teacher', payload.teacher)
      if (payload.desc) data.append('desc', payload.desc)
      if (payload.attachements) {
        payload.attachements.forEach((file) => {
          data.append('files', file)
        })
      }

      const res = await axios.post(createExerciceUrl, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const {loaded, total} = progressEvent
          if (total) {
            const percentCompleted = Math.round((loaded * 100) / total)
          }

          //dispatch({ type: 'UPLOAD_PROGRESS', payload: percentCompleted });
        },
      })
      const {exercice} = res.data
      return {
        exercice,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const updateExercice = createAsyncThunk(
  'exercice/update',
  async (payload: UpdateExerciceRequest, {rejectWithValue}) => {
    try {
      const data = new FormData()
      if (payload.id) data.append('id', payload.id)
      if (payload.title) data.append('title', payload.title)
      if (payload.deadline) data.append('deadline', payload.deadline)
      if (payload.classrooms) data.append('classrooms', JSON.stringify(payload.classrooms))
      if (payload.establishement) data.append('establishement', payload.establishement)
      if (payload.specificStudents)
        data.append('specificStudents', JSON.stringify(payload.specificStudents))
      if (payload.toStudents) data.append('toStudents', JSON.stringify(payload.toStudents))
      if (payload.subject) data.append('subject', payload.subject)
      if (payload.teacher) data.append('teacher', payload.teacher)
      if (payload.desc) data.append('desc', payload.desc)
      if (payload.attachements) {
        payload.attachements.forEach((file) => {
          if (file instanceof File) data.append('files', file)
        })
      }
      if (payload.deletedAttachements) {
        data.append('deletedAttachements', JSON.stringify(payload.deletedAttachements))
      }
      const res = await axios.post(updateExerciceUrl, data)
      const {exercice} = res.data
      return {
        exercice,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const deleteExercice = createAsyncThunk(
  'exercice/delete',
  async (payload: DeleteExerciceRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(deleteExerciceUrl, payload)
      const {exercice} = res.data
      return {
        exercice,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const endExercice = createAsyncThunk(
  'exercice/end',
  async (payload: EndExerciceRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(endExerciceUrl, payload)
      const {exercice} = res.data
      return {
        exercice,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const undoExercice = createAsyncThunk(
  'exercice/undo',
  async (payload: UndoExerciceRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(undoExerciceUrl, payload)
      const {exercice} = res.data
      return {
        exercice,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)
